import React, { useEffect } from 'react'
import GlobalStyle from '@/styles/global-style'
import dynamic from 'next/dynamic'
import { ThemeProvider } from 'styled-components'
import { i18next } from '@/lib/i18n'
import { webTheme } from '@/styles/theme'
import { Provider } from 'mobx-react'
import { getUuid, isApp, isServer, setGlobalConfig } from '@/lib/utils'
import { initStore, Store } from '@/store'
import { GA } from '@/components/ga'
import App, { AppContext } from 'next/app'
import { eventLogProducer } from '@/lib/event-logger'
import { RouteEventProvider } from '@/lib/route-event'
/** other css */
import { RevealGlobalStyles } from 'react-genie'
import '@/lib/css/swiper.css'
import '@/lib/css/pagination.css'
import '@/lib/css/navigation.min.css'
import 'react-toastify/dist/ReactToastify.css'

import { ToastContainer } from 'react-toastify'
import { registerGoback } from '@/lib/common-bridge'
const Download = dynamic(import('@/components/common/downLoad'))

interface IProps {
  [key: string]: any
}

function AppWrapper({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (isApp()) {
      registerGoback()
    }
  }, [isApp, registerGoback])

  return <>{children}</>
}

class MainApp extends App<IProps> {
  mobxStore: Store
  hideDownload: boolean

  componentDidMount() {
    getUuid()
    eventLogProducer.init()
    setGlobalConfig()
  }

  static async getInitialProps(appContext: AppContext) {
    const ctx: any = appContext.ctx
    ctx.mobxStore = initStore()
    const appProps = await App.getInitialProps(appContext)
    return {
      ...appProps,
      initialMobxState: ctx.mobxStore,
    }
  }

  constructor(props: any) {
    super(props)
    this.mobxStore = isServer ? props.initialMobxState : initStore(props.initialMobxState)

    const language = props.router.locale === 'en-us' ? 'EN' : 'ID'
    initStore().ConfigStore.setLanguage(language)
    i18next.changeLanguage(language)
    const { asPath } = props.router
    this.hideDownload =
      asPath.match('isFrom=notification')?.length > 0 ||
      asPath.includes('/pintar-discover') ||
      asPath.includes('isFrom=me') ||
      asPath.includes('/ai-bot') ||
      asPath.includes('/e-consent')
  }

  render() {
    const { Component, pageProps } = this.props
    return (
      <AppWrapper>
        <Provider {...this.mobxStore}>
          <RouteEventProvider>
            <ThemeProvider theme={webTheme}>
              <ToastContainer
                newestOnTop
                enableMultiContainer
                autoClose={3000}
                position="top-center"
                hideProgressBar
                closeButton={false}
              />
              <GlobalStyle />
              <RevealGlobalStyles />
              <Component {...pageProps} />
              {process.env.NEXT_PUBLIC_ENV === 'production' && <GA />}
              {!this.hideDownload && <Download />}
            </ThemeProvider>
          </RouteEventProvider>
        </Provider>
      </AppWrapper>
    )
  }
}

export default MainApp
